import { Moment } from "moment";

export const formatDate = (date: Moment | null): string | null =>
  date ? date.format("YYYY-MM-DD") : null;
